module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 90 cm.675ac10d.jpg";